import React from 'react';
import PropTypes from 'prop-types';
import "@fontsource/raleway";
import Header from '../components/Header/Header';
import Footer from './Footer';
import 'assets/stylesheets/application.scss';

const Layout = ({ children, pageName }) => {
  let className = '';

  if (pageName) {
    className = `wrapper page-${pageName}`;
  }

  return (
    <>
      <Header />
      <div className={className}>
        <main>{children}</main>
        <Footer />
      </div>
    </>
  );
};

Layout.propTypes = {
  children: PropTypes.node.isRequired,
};

export default Layout;
